import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = 'https://csksportswear.in/backend/api';

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [settings, setSettings] = useState({});

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    fetchSettings();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const fetchSettings = async () => {
    try {
      const res = await axios.get(`${API}/settings.php?action=public`);
      if (res.data.success) setSettings(res.data.data);
    } catch (err) { console.error(err); }
  };

  const scrollTo = (id) => {
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) {
      const offset = 70;
      const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  const navLinks = [
    { label: 'Home', id: 'hero' },
    { label: 'Products', id: 'products' },
    { label: 'Gallery', id: 'gallery' },
    { label: 'About', id: 'about' },
    { label: 'Contact', id: 'contact' },
  ];

  return (
    <>
      <style>{`
        .navbar {
          position: fixed; top: 0; left: 0; right: 0; z-index: 999;
          transition: all 0.3s ease;
          padding: 16px 0;
          background: ${scrolled ? 'rgba(10,10,10,0.95)' : 'transparent'};
          backdrop-filter: ${scrolled ? 'blur(20px)' : 'none'};
          border-bottom: ${scrolled ? '1px solid rgba(255,255,255,0.08)' : 'none'};
        }
        .nav-container {
          max-width: 1280px; margin: 0 auto;
          padding: 0 24px; display: flex;
          align-items: center; justify-content: space-between;
        }
        .nav-logo {
          display: flex; align-items: center;
          gap: 10px; cursor: pointer;
          text-decoration: none;
        }
        .nav-links {
          display: flex; align-items: center; gap: 32px;
        }
        .nav-link {
          color: rgba(255,255,255,0.8); font-size: 14px;
          font-weight: 500; cursor: pointer;
          transition: color 0.2s; background: none;
          border: none; font-family: Inter, sans-serif;
        }
        .nav-link:hover { color: #0066FF; }
        .nav-cta {
          background: linear-gradient(135deg, #0066FF, #0052CC);
          color: white; padding: 10px 24px;
          border-radius: 8px; font-size: 14px;
          font-weight: 700; cursor: pointer;
          border: none; font-family: Inter, sans-serif;
          transition: opacity 0.2s;
        }
        .nav-cta:hover { opacity: 0.9; }
        .nav-hamburger {
          display: none; background: none;
          border: none; cursor: pointer;
          flex-direction: column; gap: 5px; padding: 4px;
        }
        .nav-hamburger span {
          display: block; width: 24px; height: 2px;
          background: white; transition: all 0.3s;
          border-radius: 2px;
        }
        .nav-mobile {
          display: none;
          position: fixed; top: 60px;
          left: 0; right: 0;
          background: rgba(10,10,10,0.98);
          backdrop-filter: blur(20px);
          border-bottom: 1px solid rgba(255,255,255,0.08);
          padding: 16px 24px;
          flex-direction: column; gap: 4px; z-index: 998;
        }
        .nav-mobile.open { display: flex; }
        .nav-mobile-link {
          color: rgba(255,255,255,0.8); font-size: 15px;
          font-weight: 500; cursor: pointer;
          padding: 12px 0;
          border-bottom: 1px solid rgba(255,255,255,0.06);
          background: none; border-left: none;
          border-right: none; border-top: none;
          font-family: Inter, sans-serif;
          text-align: left; width: 100%;
          transition: color 0.2s;
        }
        .nav-mobile-link:hover { color: #0066FF; }
        @media (max-width: 768px) {
          .nav-links { display: none; }
          .nav-hamburger { display: flex; }
        }
      `}</style>

      <nav className="navbar">
        <div className="nav-container">
          {/* Logo */}
          <div className="nav-logo" onClick={() => scrollTo('hero')}>
            {settings.site_logo ? (
              <img
                src={settings.site_logo}
                alt={settings.site_name || 'CSK'}
                style={{ height: '40px', maxWidth: '160px', objectFit: 'contain' }}
              />
            ) : (
              <>
                <span style={{ color: '#DC2626', fontSize: '24px' }}>★</span>
                <div>
                  <div style={{ fontFamily: 'Montserrat', fontSize: '16px', fontWeight: 900, letterSpacing: '3px', color: 'white' }}>
                    {settings.site_name || 'CSK'}
                  </div>
                  <div style={{ fontSize: '8px', color: '#475569', letterSpacing: '2px', fontFamily: 'Inter' }}>
                    {settings.site_tagline || 'SPORTSWEAR'}
                  </div>
                </div>
              </>
            )}
          </div>

          {/* Desktop Links */}
          <div className="nav-links">
            {navLinks.map(link => (
              <button key={link.id} className="nav-link" onClick={() => scrollTo(link.id)}>
                {link.label}
              </button>
            ))}
            <button className="nav-cta" onClick={() => scrollTo('contact')}>
              Get Quote
            </button>
          </div>

          {/* Hamburger */}
          <button className="nav-hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            <span style={{ transform: menuOpen ? 'rotate(45deg) translateY(7px)' : 'none' }} />
            <span style={{ opacity: menuOpen ? 0 : 1 }} />
            <span style={{ transform: menuOpen ? 'rotate(-45deg) translateY(-7px)' : 'none' }} />
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div className={`nav-mobile ${menuOpen ? 'open' : ''}`}>
        {navLinks.map(link => (
          <button key={link.id} className="nav-mobile-link" onClick={() => scrollTo(link.id)}>
            {link.label}
          </button>
        ))}
        <button className="nav-cta" onClick={() => scrollTo('contact')} style={{ marginTop: '8px', width: '100%' }}>
          Get Quote
        </button>
      </div>
    </>
  );
}

export default Navbar;
